import { styled } from "@mui/material";

const Main = styled("main")`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => theme.spacing(2.5)};
`;

const Container = styled("div")`
  display: flex;
  flex-direction: column;
  height: inherit;
`;

export { Main, Container };
